import React from 'react';
import PropTypes from 'prop-types';
import 'leaflet/dist/leaflet.css';
import {
  AttributionControl,
  MapContainer,
  Marker,
  Popup,
  TileLayer,
} from 'react-leaflet';
import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { Box, makeStyles } from '@material-ui/core';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import marker from '../../../../../public/static/icons/seenic/map-pin-indigo.png';

delete L.Icon.Default.prototype._getIconUrl;

const customIcon = new L.Icon({
  iconUrl: marker,
  iconSize: [40, 44],
  iconAnchor: [21, 41],
  popupAnchor: [0, -41],
  shadowUrl: markerShadow,
  shadowSize: [41, 41],
  shadowAnchor: [12.5, 41],
});

const useStyles = makeStyles(() => ({
  fullScreenMap: {
    height: '400px',
    width: '840px',
    borderRadius: 'var(--utilities-border-radius-default)',
    '@media (max-width: 1600px)': {
      width: '700px',
    },
    '& .leaflet-tile-pane': {
      filter: 'contrast(1.05) brightness(1.05) saturate(0.25)',
    },
  },
}));

const HeatMap = ({ data }) => {
  const classes = useStyles();

  const groupedData = data.reduce((acc, current) => {
    const key = current.city.toLowerCase();
    if (!acc[key]) {
      acc[key] = { ...current };
    } else {
      acc[key].visitsCount += current.visitsCount;
    }
    return acc;
  }, {});

  return (
    <Box className={classes.heatMap}>
      <MapContainer
        className={classes.fullScreenMap}
        center={[40.0, -100.0]}
        zoom={4}
        minZoom={1}
        maxZoom={19}
        maxBounds={[
          [-90, -180],
          [90, 180],
        ]}
        scrollWheelZoom
        attributionControl={false}
      >
        <AttributionControl prefix={false} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={19}
        />
        <MarkerClusterGroup
          spiderfyOnMaxZoom={false}
          showCoverageOnHover={false}
        >
          {Object.values(groupedData).map(location => (
            <Marker
              key={location.locationId + location.id}
              position={[location.latitude, location.longitude]}
              icon={customIcon}
            >
              <Popup>
                City: {location.city}
                <br />
                Location Views: {location.visitsCount}
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>
    </Box>
  );
};

HeatMap.propTypes = {
  data: PropTypes.array,
};

export default HeatMap;
